import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _ChairDirk = () => {
    return (
        <g transform="translate(-446.859670 -165.585560)">
          <path fill="#803300" fillOpacity="1" stroke="none" strokeWidth="0.68299" stopColor="#000000" d="m 491.71914,165.58556 v 95.74935 h -4.32737 v -38.76859 h -36.20472 v 38.76859 h -4.32738 v -38.76859 -4.2838 h 4.32738 36.20472 v -52.69696 z"/>
        </g>
    );
}

const ChairDirk = withSizePositionAngle(_ChairDirk, 44.859470, 95.749350);

export default ChairDirk;